import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit';
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER, Persistor } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import rootReducer, { RootState } from './root-reducer';
import { organizationContextSwitcherMiddleware } from 'features/job-seeker-on-behalf-of-organization-admin';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'organizationSetup', 'employerSetup', 'jobSeekerInvitation', 'jobSeekerOnBehalfOfOrganizationAdmin'],
};

const persistedReducer = persistReducer<RootState>(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
    },
  }).concat(organizationContextSwitcherMiddleware),
  devTools: process.env.NODE_ENV === 'development',
});

export const persistor: Persistor = persistStore(store);
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action>;
